import type { AppLocale, LocaleDefinition } from "./types";

export const LOCALE_STORAGE_KEY = "siteLocale";
/** Set when the visitor picks a language; auto geo/default must not override on reload. */
export const LOCALE_USER_CHOSEN_KEY = "siteLocaleUserChosen";
/** Last ipapi country code; used for instant locale on reload before geo returns. */
export const GEO_COUNTRY_STORAGE_KEY = "siteGeoCountry";
/** Last /api/site-config/ default_locale for visitors outside mapped countries. */
export const SITE_DEFAULT_LOCALE_STORAGE_KEY = "siteDefaultLocale";

export const LOCALES: LocaleDefinition[] = [
  {
    code: "ru",
    shortCode: "ru",
    nameKey: "lang.name.ru",
    flagVariant: "tricolor",
    stripes: ["#ffffff", "#0039a6", "#d52b1e"],
  },
  {
    code: "en",
    shortCode: "en",
    nameKey: "lang.name.en",
    flagVariant: "union-jack",
    stripes: ["#012169", "#ffffff", "#c8102e"],
  },
  {
    code: "az",
    shortCode: "az",
    nameKey: "lang.name.az",
    flagVariant: "azerbaijan",
    stripes: ["#00b5e2", "#ef3340", "#3f9c35"],
  },
];

export function isAppLocale(
  value: string | null | undefined,
): value is AppLocale {
  return value === "ru" || value === "en" || value === "az";
}
